<template>
  <div class="main-container">
    <div class="sub-header fixed" style="position: fixed; top: 0">
      <div class="left-back" style="display: flex; align-items: center">
        <div style="flex: auto">
          <a class="icon" href="/course" title="返回上一级">
            <i class="el-icon-back"></i>
          </a>
          <span>课程列表</span>
        </div>
        <div>
          <el-button @click="changeExpandAll(false)" icon="el-icon-arrow-up" size="mini" circle></el-button>
          <el-button @click="changeExpandAll(true)" icon="el-icon-arrow-down" size="mini" circle></el-button>
          <!-- <i class="el-icon-arrow-up" style="cursor: pointer"></i>
          <i class="el-icon-arrow-down" style="cursor: pointer"></i> -->
        </div>
      </div>
      <div class="right-title">
        <template v-if="!courseCatalogInfo.parentName">
          <a><span>{{ courseCatalogInfo.name }}</span></a>
        </template>
        <template v-else>
          <a><span>{{ courseCatalogInfo.parentName }}</span></a>
          <em>/</em>
          <a>{{ courseCatalogInfo.name }}</a>
        </template>
      </div>
    </div>
    <div class="main-con" style="
        margin-top: 68px;
        display: flex;
        flex-direction: column;
        background-color: #efefef;
      ">
      <div class="left-menu" style="position: fixed">
        <div class="catalog-con">
          <div class="inner">
            <p class="title" style="display: none">目录</p>
            <div class="item-box">
              <div class="item" v-for="catalogData in courseCatalogData" :key="catalogData.id">
                <div class="section" :class="{
                  'active-bg': courseCatalogInfo.id === catalogData.id,
                }" style="display: flex; align-items: center">
                  <div style="flex: auto">
                    <a v-if="catalogData.type" :href="`/read/${catalogData.id}`">
                      <p class="sec_name">{{ catalogData.name }}</p>
                    </a>
                    <p v-else class="sec_name">{{ catalogData.name }}</p>
                  </div>
                  <div style="padding: 6px;">
                    <i v-if="catalogData.expand" @click="catalogData.expand = !catalogData.expand"
                      class="el-icon-arrow-up" style="cursor: pointer"></i>
                    <i v-if="!catalogData.expand" @click="catalogData.expand = !catalogData.expand"
                      class="el-icon-arrow-down" style="cursor: pointer"></i>
                    <!-- <el-button
                      v-if="catalogData.expand"
                      @click="catalogData.expand = !catalogData.expand"
                      icon="el-icon-arrow-up"
                      size="mini"
                      circle
                    ></el-button>
                    <el-button
                      v-if="!catalogData.expand"
                      @click="catalogData.expand = !catalogData.expand"
                      icon="el-icon-arrow-down"
                      size="mini"
                      circle
                    ></el-button> -->
                  </div>
                </div>
                <ul v-if="catalogData.expand">
                  <li v-for="node in catalogData.children" :key="node.id" :class="{
                    'active-bg': courseCatalogInfo.id === node.id,
                  }">
                    <a v-if="node.type" :href="`/read/${node.id}`">
                      <div class="articleName">
                        {{ node.name }}
                      </div>
                    </a>
                    <div v-else class="articleName">
                      {{ node.name }}
                    </div>
                  </li>
                </ul>
              </div>
              <!-- <div class="item">
                <div class="section">
                  <p class="sec_name">第2章：设置</p>
                </div>
                <ul>
                  <li>
                    <a>
                      <div class="articleName">
                        03 开篇词：商城首页还不明白吗？
                      </div>
                    </a>
                  </li>
                  <li>
                    <a>
                      <div class="articleName">04 商城首页商城设置</div>
                    </a>
                  </li>
                  <li>
                    <a>
                      <div class="articleName">04 商城首页商城设置</div>
                    </a>
                  </li>
                  <li>
                    <a>
                      <div class="articleName">04 商城首页商城设置</div>
                    </a>
                  </li>
                  <li>
                    <a>
                      <div class="articleName">04 商城首页商城设置</div>
                    </a>
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="right-content">
        <div class="container" style="max-width: 1200px; min-width: 800px">
          <div class="center_con" style="margin-top: 45px">
            <div class="article-con">
              <div class="art-buy">
                <img v-show="courseData.mainImage" class="img l" :src="`${fileUrl}/${courseData.mainImage}`" />
                <div class="text l">
                  <p class="title">{{ courseData.title }}</p>
                  <div class="price_con">
                    <p class="price_ori">原价：免费</p>
                  </div>
                </div>
              </div>
              <div class="art-title">{{ courseCatalogInfo.name }}</div>
              <div class="art-info">
                <span>
                  更新时间：{{
                    new Date(courseCatalogInfo.creationTime)
                    | parseTime("{y}-{m}-{d}")
                  }}
                </span>
              </div>
              <div class="art-content">
                <!-- Html -->
                <div v-if="courseCatalogInfo.type === '1'" v-html="content" style="overflow: hidden"></div>
                <!-- Video -->
                <video-player v-else-if="
                  courseCatalogInfo.type === '3' && content != undefined
                " :sources="[
                    {
                      src: `${fileUrl}/${content}`,
                      type: 'video/mp4',
                    },
                  ]"></video-player>
                <!-- Pdf -->
                <pdf-viewer v-else-if="
                  courseCatalogInfo.type === '2' && content != undefined
                " :pdfPath="`${fileUrl}/${content}`" @firstNode="handleFirstNode"
                  @lastNode="handleLastNode"></pdf-viewer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  courseContextService,
  courseCatalogService,
  courseService,
} from "@/api/courses";
import VideoPlayer from "./components/VideoPlayer";
import PdfViewer from "./components/PdfViewer";

export default {
  name: "Course",
  components: { VideoPlayer, PdfViewer },
  data() {
    return {
      actionIndex: 0,

      courseData: {
        id: undefined,
        mainImage: undefined, // 主图
        title: "", // 标题
        longTitle: "", // 长标题
        platform: undefined, // 平台
        type: undefined, // 类型
        level: undefined, // 层次
        intro: undefined, // 介绍
      },
      courseCatalogInfo: {
        id: undefined,
        name: "",
        parentId: undefined,
        type: undefined,

        parentName: undefined,
        //content: undefined
      },
      content: undefined,
      courseCatalogData: [], // 章节

      fileUrl: process.env.VUE_APP_FILE_URL,
    };
  },
  created() {
    const id = this.$route.params && this.$route.params.id;
    this.getCatalog(id);
  },
  methods: {
    // 获取章节信息
    getCatalog(catalogId) {
      courseCatalogService.getCourseCatalogById(catalogId).then((res) => {
        this.courseCatalogInfo = res;
        var courseId = res.courseId;

        this.getCourse(courseId);
        this.getCatalogList(courseId);
        this.getCourseContext(catalogId, res.type);
      });
    },
    // 获取课程
    getCourse(id) {
      courseService
        .getCourseById(id)
        .then((res) => {
          this.courseData = res;
          //this.imageUrl = `${process.env.VUE_APP_FILE_URL}/${res.mainImage}`
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取目录列表
    getCatalogList(courseId) {
      courseCatalogService.getCourseCatalogTreeList(courseId).then((res) => {
        this.courseCatalogData = res.items.map((item) => {
          return Object.assign(item, { expand: false });
        });

        if (this.courseCatalogInfo.parentId) {
          const currCourseCatalog = this.courseCatalogData.find(
            (i) => i.id === this.courseCatalogInfo.parentId
          );
          currCourseCatalog.expand = true;
          this.courseCatalogInfo.parentName = currCourseCatalog?.name;
        }
      });
    },
    // 获取章节内容
    getCourseContext(catalogId, type) {
      courseContextService
        .getCourseContextByCatalogIdAndType(catalogId, type)
        .then((res) => {
          this.content = res.items[0]?.content;
        });
    },
    toCourseCatalog(catalogId) {
      courseCatalogService.getCourseCatalogById(catalogId).then((res) => {
        this.courseCatalogInfo = res;
        //var courseId = res.courseId;

        // 当前章节展开
        if (this.courseCatalogInfo.parentId) {
          const currCourseCatalog = this.courseCatalogData.find(
            (i) => i.id === this.courseCatalogInfo.parentId
          );
          currCourseCatalog.expand = true;
        }

        //this.getCourse(courseId);
        //this.getCatalogList(courseId);
        this.getCourseContext(catalogId, res.type);
      });
    },
    handleFirstNode() {
      const catalogId = this.courseCatalogInfo.id; //this.$route.params && this.$route.params.id;

      // 找当前阅读章
      for (let index = 0; index < this.courseCatalogData.length; index++) {
        const chapter = this.courseCatalogData[index];
        if (chapter.id === catalogId) {
          // 上一章
          const chapterId = this.filterPreviousChapter(
            this.courseCatalogData,
            index - 1
          );

          this.toCourseCatalog(chapterId);
          // location.href = `/read/${chapterId}`;
        } else {
          // 找当前阅读节
          for (
            let nodeIndex = 0;
            nodeIndex < chapter.children.length;
            nodeIndex++
          ) {
            const node = chapter.children[nodeIndex];
            if (node.id === catalogId) {
              // 上一节
              const nodeId = this.filterPreviousNode(
                this.courseCatalogData,
                index,
                chapter.children,
                nodeIndex - 1
              );

              this.toCourseCatalog(nodeId);
              // location.href = `/read/${nodeId}`;
            }
          }
        }
      }
    },
    handleLastNode() {
      const catalogId = this.courseCatalogInfo.id; //this.$route.params && this.$route.params.id;

      // 找当前阅读章
      for (let index = 0; index < this.courseCatalogData.length; index++) {
        const chapter = this.courseCatalogData[index];
        if (chapter.id === catalogId) {
          // 下一章
          // if (index <= this.courseCatalogData.length) {
          //   const nextChapter = this.courseCatalogData[index + 1];
          //   location.href = `/read/${nextChapter.id}`;
          // }
          const chapterId = this.filterNextChapter(
            this.courseCatalogData,
            index + 1
          );

          this.toCourseCatalog(chapterId);
          // location.href = `/read/${chapterId}`;
        } else {
          // 找当前阅读节
          for (
            let nodeIndex = 0;
            nodeIndex < chapter.children.length;
            nodeIndex++
          ) {
            const node = chapter.children[nodeIndex];
            if (node.id === catalogId) {
              // 下一节
              // const nextNode = chapter.children[nodeIndex + 1];
              // if (nextNode) {
              //   console.log(nextNode);
              //   //console.log(nextNode.name);
              //   location.href = `/read/${nextNode.id}`;
              // } else {
              //   // 下一章
              //   if (index <= this.courseCatalogData.length) {
              //     const nextChapter = this.courseCatalogData[index + 1];
              //     location.href = `/read/${nextChapter.id}`;
              //   }
              // }
              const nodeId = this.filterNextNode(
                this.courseCatalogData,
                index,
                chapter.children,
                nodeIndex + 1
              );

              this.toCourseCatalog(nodeId);
              // location.href = `/read/${nodeId}`;
            }
          }
        }
      }
    },
    // 从章开始过滤 取下一个
    filterNextChapter(catalogData, index) {
      for (let i = index; i < catalogData.length; i++) {
        // 章
        const nextChapter = catalogData[i];
        if (nextChapter.type) {
          return nextChapter.id;
        } else {
          // 节
          for (let j = 0; j < nextChapter.children.length; j++) {
            const nextNode = nextChapter.children[j];
            if (nextNode.type) {
              return nextNode.id;
            }
          }
        }
      }
      return null;
    },
    // 过滤章 取上一个
    filterPreviousChapter(catalogData, index) {
      for (let i = index; i >= 0; i--) {
        // 章
        const nextChapter = catalogData[i];
        if (nextChapter.type) {
          return nextChapter.id;
        } else {
          // 节
          for (let j = nextChapter.children.length - 1; j >= 0; j--) {
            const nextNode = nextChapter.children[j];
            if (nextNode.type) {
              return nextNode.id;
            }
          }
        }
      }
      return null;
    },
    // 过滤节
    filterNextNode(chapterData, chapterIndex, catalogData, index) {
      for (let i = index; i < catalogData.length; i++) {
        // 下一节
        const nextNode = catalogData[i];
        if (nextNode.type) {
          return nextNode.id;
        }
      }
      // 下一章
      return this.filterNextChapter(chapterData, chapterIndex + 1);
    },
    // 过滤节
    filterPreviousNode(chapterData, chapterIndex, catalogData, index) {
      for (let i = index; i >= 0; i--) {
        // 上一节
        const nextNode = catalogData[i];
        if (nextNode.type) {
          return nextNode.id;
        }
      }
      return this.filterPreviousChapter(chapterData, chapterIndex - 1);
    },
    // 展开/折叠 全部
    changeExpandAll(state) {
      this.courseCatalogData.forEach(item => {
        item.expand = state
      });
    }
  },
};
</script>

<style scoped>
.sub-header {
  position: relative;
  width: 100%;
  height: 68px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  z-index: 4;
  border-top: 1px solid #f3f5f6;
  box-sizing: border-box;
  transition: top 0.3s 0.3s;
  -moz-transition: top 0.3s 0.3s;
  -webkit-transition: top 0.3s 0.3s;
  -o-transition: top 0.3s 0.3s;
}

.sub-header .fixed {
  position: fixed;
  top: 0;
}

.left-back {
  position: absolute;
  left: 0;
  top: 0;
  width: 296px;
  padding: 20px;
  box-sizing: border-box;
  transition: left 0.3s;
  -moz-transition: left 0.3s;
  -webkit-transition: left 0.3s;
  -o-transition: left 0.3s;
}

.left-back a.icon {
  display: inline-block;
  width: 28px;
  height: 28px;
  margin-right: 16px;
  vertical-align: middle;
}

.left-back a i {
  font-size: 28px;
  color: #9199a1;
  text-align: center;
  line-height: 28px;
}

.left-back span {
  font-size: 18px;
  color: #1c1f21;
  font-weight: 600;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  vertical-align: middle;
}

.right-title {
  margin-left: 296px;
  padding: 20px 24px;
  font-size: 14px;
  color: #9199a1;
  position: relative;
  padding-left: 68px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  transition: margin-left 0.3s;
  -moz-transition: margin-left 0.3s;
  -webkit-transition: margin-left 0.3s;
  -o-transition: margin-left 0.3s;
}

.right-title em {
  padding: 0 4px;
}

.right-title span {
  line-height: 28px;
  font-size: 18px;
  color: #1c1f21;
}

.main-con {}

.main-con .left-menu {
  position: absolute;
  top: 68px;
  left: 0;
  bottom: 0;
  width: 296px;
  z-index: 3;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
}

.left-menu .catalog-con {
  position: absolute;
  width: 296px;
  top: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  /* padding-top: 58px; */
  box-sizing: border-box;
}

.catalog-con .inner {
  position: relative;
  height: 100%;
  width: 100%;
}

.catalog-con .inner .title {
  position: absolute;
  top: -58px;
  left: 0;
  right: 0;
  font-size: 18px;
  color: #1c1f21;
  line-height: 25px;
  margin: 0 10px;
  padding: 16px 6px;
  border-bottom: 1px solid #f3f5f6;
}

.catalog-con .inner .item-box {
  padding: 0 10px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.active-bg {
  background: #f0f8ff;
}

.item .section {
  width: 100%;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
}

.section .sec_name {
  width: 100%;
  font-size: 15px;
  color: #1c1f21;
  line-height: 18px;
  text-align: left;
  font-weight: 700;
  padding: 16px 6px;
}

ol,
ul {
  list-style: none;
}

.item ul li {
  position: relative;
  box-sizing: border-box;
  padding: 16px 6px;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
}

.item ul li .articleName {
  max-width: 380px;
  font-size: 15px;
  color: #1c1f21;
  line-height: 24px;
  /* margin-bottom: 6px; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.main-con .right-content {
  padding-left: 296px;
  position: relative;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
}

.right-content .container {
  /* width: 1000px; */
  margin: 0 auto;
  /* display: none; */
}

.right-content .container .center_con {
  /* width: 1000px; */
  margin-top: 52px;
  margin-bottom: 36px;
}

.container .center_con .article-con {
  padding: 52px 64px 68px;
  background: #fff;
  position: relative;
}

.art-buy {
  position: absolute;
  left: 0;
  top: 0;
  /* width: 952px; */
  min-width: calc(100% - 48px);
  height: 132px;
  box-sizing: border-box;
  padding: 0 32px;
  padding: 0 8px;
  margin: 0 24px;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
}

.l {
  float: left;
}

.art-buy .img {
  /* width: 96px; */
  height: 128px;
  margin-top: -20px;
  margin-right: 19px;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 4px 8px 0 rgba(28, 31, 33, 0.06),
    0 8px 16px 0 rgba(28, 31, 33, 0.06), 0 12px 24px 0 rgba(28, 31, 33, 0.06),
    0 16px 32px 0 rgba(28, 31, 33, 0.06);
  border-radius: 8px;
}

.art-buy .text {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
}

.art-buy .text .title {
  /* width: 348px; */
  font-weight: 700;
  font-size: 20px;
  color: #1c1f21;
  line-height: 22px;
  text-align: left;
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.art-buy .text .price_con .price_ori {
  font-weight: 700;
  font-size: 12px;
  color: #9199a1;
  text-align: left;
  line-height: 12px;
  margin-right: 8px;
}

.article-con .art-title {
  font-size: 28px;
  color: #1c1f21;
  text-align: left;
  line-height: 36px;
  font-weight: 700;
  margin-bottom: 16px;

  margin-top: 112px;
}

.art-info {
  margin-bottom: 8px;
}

.art-info span {
  font-size: 12px;
  color: #9199a1;
  line-height: 24px;
}

.art-content {
  margin-bottom: 24px;
  line-height: 32px !important;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, STHeiti,
    "Microsoft Yahei", sans-serif;
  font-size: 16px;
  line-height: 32px;
  color: #1c1f21;
  word-wrap: break-word;
}
</style>
